import { isPlatformOnlySuperAdmin } from '../utils/platformRoles';
import { isConsultoriaTenant, isRequesterRole, isStaffHomeRole } from '../utils/tenantProfile';

export const PLATFORM_ADMIN_PATH = '/super-admin';
export const PLATFORM_ADMIN_LABEL = 'Gestão da Plataforma';
export const PLATFORM_ADMIN_DESCRIPTION = 'Organizações, assinaturas e cobrança';

/**
 * Caminho da home da área autenticada (dashboard em `/`).
 * Super admin sem organização vai direto ao console da plataforma.
 * Respeita `PUBLIC_URL` do CRA quando o app é servido em subpath.
 */
export function getAppHomePath(user, tenant) {
  if (isPlatformOnlySuperAdmin(user)) {
    return PLATFORM_ADMIN_PATH;
  }
  if (isRequesterRole(user)) {
    return '/portal';
  }
  if (isStaffHomeRole(user)) {
    return '/me';
  }
  const roles = (user?.roles || []).map((r) => String(r).toLowerCase());
  if (isConsultoriaTenant(tenant) && roles.includes('coordenador')) {
    return '/portfolio';
  }
  const base = process.env.PUBLIC_URL || '';
  if (!base) return '/';
  return base.endsWith('/') ? base : `${base}/`;
}
